<template>
	<div
		:id="id"
		v-bind="$attrs"
		:aria-hidden="isActive ? undefined : 'true'"
		aria-roledescription="slide"
		class="carousel-item"
		:class="isActive ? undefined : 'hide'"
		role="group"
	>
		<slot>
			<div class="carousel-image">
				<VBtn
					class="carousel-img-btn"
					:disabled="isActive ? undefined : true"
					:elevation="0"
					:href="href"
					:ripple="false"
					:tabindex="isActive ? 0 : -1"
					:title="imgAlt"
					:to="to"
					@click="emitClickEvent"
				>
					<img
						:alt="imgAlt"
						class="w-100"
						:src="imgSrc"
					>
				</VBtn>
			</div>
		</slot>
	</div>
</template>

<script setup lang="ts">
	import { PropType } from 'vue';
	import { RawLocation } from 'vue-router';
	import { VBtn } from 'vuetify/lib';

	const props = defineProps({
		href: {
			type: String,
			default: undefined,
		},
		id: {
			type: String,
			required: true,
		},
		imgAlt: {
			type: String,
			default: '',
		},
		imgSrc: {
			type: String,
			default: undefined,
		},
		isActive: {
			type: Boolean,
			default: undefined,
		},
		to: {
			type: [Array, Object, String] as PropType<RawLocation>,
			default: undefined,
		},
	});

	const emit = defineEmits(['click-event']);
	const emitClickEvent = (): void => {
		emit('click-event', props.id);
	};
</script>

<style lang="scss" scoped>
	.carousel-item {
		visibility: visible;
		top: 0;
		left: 0;
		padding: 1px;
	}

	.carousel-img-btn {
		width: 100%;
		height: auto !important;
		padding: 0 !important;
		border: 0;
		background-color: transparent !important;
	}
</style>
